export const payoff = "Il Metodo prima del Mattone";
export const payoffSub = "Valore Etico, Rendimento Prevedibile.";

export const kpis = [
  { label: "Target IRR", value: "≥ 18%", note: "Tasso interno di rendimento obiettivo" },
  { label: "Cap Rate", value: "≥ 8%", note: "Rendimento a reddito sull'immobile" },
  { label: "MoC", value: "≥ 2.0x", note: "Multiple on Capital sull'operazione" },
];

export const principles = [
  {
    n: "01",
    title: "Utile prefissato, surplus retrocesso",
    desc: "Definiamo il nostro margine prima dell'operazione. Il valore in eccesso viene retrocesso, non trattenuto: il nostro guadagno non cresce sulla difficoltà di chi vende.",
  },
  {
    n: "02",
    title: "Tutela integrale del venditore",
    desc: "Un protocollo che mette la persona al centro: nessuna pressione, tempi rispettati e, dove possibile, soluzioni ponte. La dignità non è negoziabile.",
  },
  {
    n: "03",
    title: "Analisi quantitativa indipendente",
    desc: "Ogni decisione nasce dai numeri, non dalle urgenze. Modelli finanziari indipendenti proteggono l'investitore dall'emotività del mercato.",
  },
  {
    n: "04",
    title: "Trasparenza totale con gli investitori",
    desc: "Reportistica chiara, ipotesi esplicite e allineamento reale degli interessi. Comunichiamo i target come target, mai come garanzie.",
  },
];

export const founders = [
  {
    name: "Nicola Micheletti",
    initials: "NM",
    role: "Strategic Advisory & Relazioni Istituzionali",
    area: "Strutturazione operazioni · Due diligence · Controllo di gestione",
    bio: "Supervisione strategica, strutturazione delle operazioni di investimento e relazioni con i partner istituzionali. Focus su due diligence analitica e controllo di gestione.",
  },
  {
    name: "Daniele Paoletti",
    initials: "DP",
    role: "Asset Acquisition & Project Management",
    area: "Analisi del valore · Riqualificazione · Cantieri",
    bio: "Analisi tecnica del valore immobiliare, coordinamento delle fasi di riqualificazione e ottimizzazione dei processi esecutivi di cantiere.",
  },
];

export const partnerCategories = [
  "Avvocati esecutivisti",
  "Notai",
  "Geometri e progettisti",
  "Imprese edili",
  "Custodi giudiziari",
  "Commercialisti",
  "Periti e valutatori",
  "Property manager",
];

export const caseStudies = [
  {
    type: "Saldo e Stralcio",
    title: "Chiusura posizione debitoria residenziale",
    objective: "Liberare un proprietario dall'esecuzione e valorizzare l'immobile.",
    metrics: [
      { k: "Sconto sul debito", v: "-34%" },
      { k: "Tempo operazione", v: "7 mesi" },
      { k: "IRR lordo", v: "21%" },
    ],
    img: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    type: "Sviluppo Residenziale",
    title: "Riqualificazione value-add in area urbana",
    objective: "Trasformare un immobile obsoleto in unità efficienti e vendibili.",
    metrics: [
      { k: "MoC", v: "1.9x" },
      { k: "Durata", v: "14 mesi" },
      { k: "Classe energetica", v: "G → A" },
    ],
    img: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    type: "Student Housing",
    title: "Messa a reddito in polo universitario",
    objective: "Creare reddito difensivo ricorrente per posto letto.",
    metrics: [
      { k: "Cap Rate", v: "8.4%" },
      { k: "Occupazione", v: "97%" },
      { k: "Posti letto", v: "+11" },
    ],
    img: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];

export const blogPosts = [
  {
    slug: "riforma-cartabia-esecuzioni",
    title: "Riforma Cartabia ed esecuzioni immobiliari: cosa cambia",
    category: "Normativa",
    date: "2026",
    excerpt:
      "Una lettura sintetica delle novità procedurali e del loro impatto su aste e saldo e stralcio, con attenzione alla tutela del debitore.",
    body: [
      "La Riforma Cartabia ha inciso su tempi e modalità del processo esecutivo, con l'obiettivo di renderlo più rapido ed efficiente. Per chi opera nel real estate distressed, comprenderne gli effetti è essenziale per stimare correttamente i tempi di rientro.",
      "In questo articolo introduttivo delineiamo i principali cambiamenti e come li integriamo nelle nostre analisi. Il contenuto ha finalità informative e non costituisce consulenza legale.",
    ],
  },
  {
    slug: "cin-affitti-brevi",
    title: "CIN e affitti brevi: la conformità come vantaggio competitivo",
    category: "Affitti Brevi",
    date: "2026",
    excerpt:
      "Il Codice Identificativo Nazionale ridefinisce la gestione degli affitti brevi. Perché la conformità protegge reddito e reputazione.",
    body: [
      "L'introduzione del CIN ha reso la conformità un requisito non aggirabile per chi gestisce affitti brevi. Lungi dall'essere un ostacolo, rappresenta un elemento di solidità per l'investitore.",
      "Analizziamo gli adempimenti principali e come la gestione professionale trasformi la compliance in un vantaggio. Contenuto informativo, non sostitutivo di consulenza fiscale.",
    ],
  },
  {
    slug: "cedolare-secca-studenti",
    title: "Cedolare secca e locazioni a studenti: nozioni di base",
    category: "Fiscalità",
    date: "2026",
    excerpt:
      "Un'introduzione al regime della cedolare secca applicato alle locazioni a studenti universitari e alle sue implicazioni di reddito.",
    body: [
      "La cedolare secca può semplificare la fiscalità delle locazioni a studenti, con effetti sul rendimento netto dell'operazione di student housing.",
      "Presentiamo i concetti fondamentali che consideriamo nelle nostre valutazioni. Il presente testo ha scopo divulgativo e non costituisce consulenza fiscale.",
    ],
  },
];

export const blogMap = Object.fromEntries(blogPosts.map((p) => [p.slug, p]));

export const profileOptions = [
  "Investitore",
  "Proprietario",
  "Segnalatore / Partner",
  "Inquilino",
  "Altro",
];

export const capitalOptions = [
  "Fino a 50.000 €",
  "50.000 € – 150.000 €",
  "150.000 € – 500.000 €",
  "500.000 € – 1.000.000 €",
  "Oltre 1.000.000 €",
];

export const horizonOptions = ["Breve (< 12 mesi)", "Medio (1–3 anni)", "Lungo (3+ anni)"];
